<div class="edit-project-view">
    <h2 fxLayout="row wrap">
        Edit View
        <span class="view-action">
            <button *ngIf="canSave" mat-button color="warn" (click)="delete()">Delete</button>
            <a class="view-action-btn" mat-stroked-button id="cancel" (click)="cancel()"> Cancel </a>
            <button [disabled]="!editView?.viewData?.length" mat-button color="secondary" (click)="saveView(true)">Save New</button>
            <button [disabled]="!editView?.viewData?.length" *ngIf="canSave" mat-button color="primary" (click)="saveView(false)">
                Save
            </button>
        </span>
    </h2>
    <form [formGroup]="projectViewForm" class="address-input-container">
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="20px">
            <div fxFlex="1 1 50" class="group-name">
                <mat-form-field class="query-filter" appearance="outline">
                    <mat-label>Group Name</mat-label>
                    <input matInput type="text" placeholder="Name" formControlName="name" required />
                </mat-form-field>
            </div>
            <div fxFlex="1 1 auto">
                <mat-checkbox (change)="onDefaultChange($event)" [checked]="canSave && projectView.isDefault" class="checkbox"
                    >Default View</mat-checkbox
                >
            </div>
        </div>
        <div class="form-group">
            <label for="visibility" class="example-radio-group-label">Visibility:</label>
            <mat-radio-group formControlName="visibility">
                <mat-radio-button [value]="0">Only Me</mat-radio-button>
                <mat-radio-button [value]="1">Entire Company</mat-radio-button>
            </mat-radio-group>
        </div>

        <div cdkDropListGroup fxLayout="row wrap" fxLayoutGap="10px grid" fxLayoutAlign="space-between stretch">
            <div class="from-list" fxFlex="1 1 100%" fxFlex.gt-xs="1 1 50%">
                <h2>Available Columns</h2>
                <div cdkDropList [cdkDropListData]="items" class="drag-list" cdkDropListSortingDisabled (cdkDropListDropped)="drop($event)">
                    <div class="drag-box" *ngFor="let item of items" cdkDrag>
                        {{ item.viewHeader }}
                        <span class="material-icons"> menu </span>
                    </div>
                </div>
            </div>

            <div class="to-list" fxFlex="1 1 100%" fxFlex.gt-xs="0 1 50%">
                <h2>{{ projectViewForm.controls.name.value }} View</h2>

                <div cdkDropList [cdkDropListData]="basket" class="drag-list" (cdkDropListDropped)="drop($event)">
                    <div class="drag-box" *ngFor="let item of basket" cdkDrag>
                        {{ item.viewHeader }}
                        <span class="material-icons"> menu </span>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-around center" style="margin-bottom: 10px"></div>
    </form>
</div>
